





















































import { UserModel } from "../../apis";
import Vue from "vue";
import Component from "vue-class-component";
import { mapGetters } from "vuex";

@Component({
  computed: { ...mapGetters(["user", "name", "avatar", "status", "token"]) },
})
export default class AppProfile extends Vue {
  menuitems = [
    {
      icon: "",
      href: "#",
      title: "text.myProfile",
      click: (e) => {
      },
    },
    {
      icon: "",
      name: "about",
      title: "text.instructions",
      click: (e) => {
        this.$router.push({ name: "instructions" });
      },
    },
    {
      icon: "",
      name: "about",
      title: "text.aboutUs",
      click: (e) => {
        this.$router.push({ name: "about" });
      },
    },
    {
      icon: "",
      href: "#",
      title: "text.logOut",
      click: () => {},
    },
  ];

  get user() {
    return this.$store.getters.user as UserModel;
  }
}
